import { useState, useEffect } from 'react';
import { Services } from '@/services/services';
import { CurrentSession } from '@/services/repository/session';
import { Translates } from '@/services/repository/i18n';

const translationsCache = new Map();

export function useTranslations(services: Services, session: CurrentSession, namespace = 'main') {
  const [translates, setTranslates] = useState<Translates>();

  useEffect(() => {
    let isMounted = true;

    async function loadTranslations() {
      // 1. From session
      if (session?.translates) {
        setTranslates(session.translates);
        return;
      }

      // 2. From cache
      if (translationsCache.has(namespace)) {
        setTranslates(translationsCache.get(namespace));
        return;
      }

      // 3. Fetch from API
      try {
        const data = await services.i18n.get(namespace);
        translationsCache.set(namespace, data);
        if (isMounted) {
          setTranslates(data);
        }
      } catch (err) {
        console.error(`Error loading translations for "${namespace}":`, err);
      }
    }

    loadTranslations();

    return () => {
      isMounted = false;
    };
  }, [session, namespace]);

  return translates;
}
